import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegisterParams, RegisterData } from '../resolvers/register.resolver';
import { getLocaleDateString } from '../utils/date-utils';
import { getCurrentRegisterLocale, TypedActivatedRoute } from '../utils/route-utils';

@Pipe({
  name: 'aalistdate',
  standalone: false,
})
export class AaListDatePipe extends DatePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) locale: string,
    @Inject(ActivatedRoute) private route: TypedActivatedRoute<RegisterParams, RegisterData>,
  ) {
    super(locale);
  }

  getFormatForLocale(locale: string): string {
    const formatToUse = getLocaleDateString(locale);
    switch (formatToUse) {
      case 'MDY':
        return 'MM/dd/yyyy';
      case 'YMD':
        return 'yyyy-MM-dd';
      // Default is 'DMY'
      default:
        return 'dd/MM/yyyy';
    }
  }

  transform(value: any, format?: string): any {
    if (format) {
      return super.transform(value, format);
    } else {
      const defaultFormat = this.getFormatForLocale(getCurrentRegisterLocale(this.route.snapshot));
      return super.transform(value, defaultFormat);
    }
  }
}
